
import { Union, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { ModerationReason_$reflection } from "./Moderation.js";
import { union_type, option_type, string_type, record_type, class_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";
import { create, isMatch } from "../fable_modules/fable-library-js.5.3.0/RegExp.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { getCoverUrl, formatsHint, isSmallerThan, ImageDimensions } from "./Photo.js";
import { equals } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { ChallengeStatus } from "./Challenge.js";
import { concat } from "../fable_modules/fable-library-js.5.3.0/String.js";

/**
 * Why the owner's cover is not public. Reason and time only, never the moderator id.
 */
export class HiddenCoverInfo extends Record {
    constructor(Reason, HiddenAt) {
        super();
        this.Reason = Reason;
        this.HiddenAt = HiddenAt;
    }
}

export function HiddenCoverInfo_$reflection() {
    return record_type("Shared.HiddenCoverInfo", [], HiddenCoverInfo, () => [["Reason", ModerationReason_$reflection()], ["HiddenAt", class_type("System.DateTimeOffset")]]);
}

/**
 * A challenge's cover as the API returns it. Url is the 1200x630 rendition serving URL.
 * Hidden is Some only for the owner/moderators while a moderator has hidden it.
 */
export class ChallengeCoverImage extends Record {
    constructor(Url, Hidden) {
        super();
        this.Url = Url;
        this.Hidden = Hidden;
    }
}

export function ChallengeCoverImage_$reflection() {
    return record_type("Shared.ChallengeCoverImage", [], ChallengeCoverImage, () => [["Url", string_type], ["Hidden", option_type(HiddenCoverInfo_$reflection())]]);
}

export class SetCoverImageRequest extends Record {
    constructor(ChallengeId, ImageKey) {
        super();
        this.ChallengeId = ChallengeId;
        this.ImageKey = ImageKey;
    }
}

export function SetCoverImageRequest_$reflection() {
    return record_type("Shared.SetCoverImageRequest", [], SetCoverImageRequest, () => [["ChallengeId", class_type("System.Guid")], ["ImageKey", string_type]]);
}

export class HideCoverImageRequest extends Record {
    constructor(ChallengeId, Reason) {
        super();
        this.ChallengeId = ChallengeId;
        this.Reason = Reason;
    }
}

export function HideCoverImageRequest_$reflection() {
    return record_type("Shared.HideCoverImageRequest", [], HideCoverImageRequest, () => [["ChallengeId", class_type("System.Guid")], ["Reason", ModerationReason_$reflection()]]);
}

/**
 * An S3 key minted by /api/photos/upload: "photos/<guid>.<jpg|png|webp>". Nothing else may be a cover.
 */
export class CoverImageKey extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["CoverImageKey"];
    }
}

export function CoverImageKey_$reflection() {
    return union_type("Shared.CoverImageKey", [], CoverImageKey, () => [[["Item", string_type]]]);
}

const CoverImageKeyModule_pattern = "^photos/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\\.(jpg|png|webp)$";

export function CoverImageKeyModule_create(raw) {
    if (!Operators_IsNull(raw) && isMatch(create(CoverImageKeyModule_pattern), raw)) {
        return new FSharpResult$2(0, [new CoverImageKey(raw)]);
    }
    else {
        return new FSharpResult$2(1, ["Cover image is not a valid uploaded photo"]);
    }
}

export function CoverImageKeyModule_value(_arg) {
    return _arg.fields[0];
}

export const CoverImage_renditionDimensions = new ImageDimensions(1200, 630);

/**
 * Every status except Abandoned (looser than requireFullyEditable on purpose)
 */
export function CoverImage_isEditable(status) {
    return !equals(status, new ChallengeStatus(7, []));
}

/**
 * Small images are kept with a warning, never rejected
 */
export function CoverImage_isSmall(actual) {
    return isSmallerThan(CoverImage_renditionDimensions, actual);
}

export function CoverImage_altText(title) {
    return concat("Cover image for ", title);
}

export const CoverImage_hint = "Landscape photos work best; we show the middle. " + formatsHint;

export function CoverImage_url(key) {
    return getCoverUrl(CoverImageKeyModule_value(key));
}

//# sourceMappingURL=CoverImage.js.map
